import { api } from "..";

export interface BulkLockMainDealersBettingRulesPayload {
  ids: number[];
  locked: boolean;
}

export async function bulkLockMainDealersBettingRules(
  payload: BulkLockMainDealersBettingRulesPayload
): Promise<{ success: boolean; updatedCount: number }> {
  const res = await api.client.post(
    `/dealers-new/bulk-betting-rules-lock`,
    payload
  );
  return res.data;
}
